export var EMultivendorUserLevel;
(function (EMultivendorUserLevel) {
    EMultivendorUserLevel["USER"] = "USER";
    EMultivendorUserLevel["ADMIN"] = "ADMIN";
})(EMultivendorUserLevel || (EMultivendorUserLevel = {}));
export var EMultivendorOrderStatus;
(function (EMultivendorOrderStatus) {
    EMultivendorOrderStatus["SUCCESS"] = "SUCCESS";
    EMultivendorOrderStatus["FAILED"] = "FAILED";
    EMultivendorOrderStatus["NOT_PROCESS"] = "NOT-PROCESS";
    EMultivendorOrderStatus["CANCELLED"] = "CANCELLED";
})(EMultivendorOrderStatus || (EMultivendorOrderStatus = {}));
//# sourceMappingURL=interfaces.js.map